import { DATA_GRID_COLUMN_TYPES } from "StandardsTable/modules/constants";

export const FILTER_TYPES = {
  SEARCH: "SEARCH",
  STATUS: "STATUS",
  SHOW: "SHOW",
  GRADES: "GRADES",
  SUBJECT_AREAS: "SUBJECT_AREAS",
  TAGS: "TAGS",
};

export const COURSE_STANDARDS_STATUS_TYPES = {
  ACTIVE: "ACTIVE",
  ARCHIVED: "ARCHIVED",
  ALL: "ALL",
};

export const COLUMN_TYPE_MAP_TO_SKIP_FLAGS = {
  [DATA_GRID_COLUMN_TYPES.GRADE_LEVELS]: "shouldSkipGrades",
  [DATA_GRID_COLUMN_TYPES.SUBJECT_GROUP]: "shouldSkipSubjectGroups",
  [DATA_GRID_COLUMN_TYPES.TAGS]: "shouldSkipGenericTags",
};

export const ASSOCIATED_PARENT_TYPES_TO_VARIABLE = {
  GRADE: "grades",
};
